<template>
  <div>
    <b-container>
      <b-row>
        <b-col
          :cols="12"
          :class="[
            'd-flex flex-column text-center align-items-center justify-content-center text-uppercase pt-4',
            $style.myPickText
          ]"
        >
          {{ $t('predict-the-score') }}
        </b-col>
      </b-row>
      <TheSummerMatchOverview :match="match" />
      <b-row class="pb-4">
        <b-col
          :cols="5"
          class="d-flex justify-content-center align-items-center"
        >
          <div class="d-flex justify-content-center">
            <BaseScoreInput
              v-model="team1score"
            />
          </div>
        </b-col>
        <b-col :cols="2" />
        <b-col
          :cols="5"
          class="d-flex justify-content-center align-items-center"
        >
          <div class="d-flex justify-content-center">
            <BaseScoreInput
              v-model="team2score"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BaseScoreInput from '@/pages/RoundDetail/Components/Atoms/BaseScoreInput'
import TheSummerMatchOverview from './TheSummerMatchOverview'

export default {
  name: 'TheUpcomingSummerMatch',
  components: {
    TheSummerMatchOverview,
    BaseScoreInput,
  },
  props: {
    match: {
      type: Object,
      default: () => {},
    },
    myScorePredictions: {
      type: Object,
      default: () => ({
        team1score: null,
        team2score: null,
      }),
    },
  },
  data() {
    return {
      scoreChangeTimeout: null,
      team1score: null,
      team2score: null,
    }
  },
  watch: {
    myScorePredictions(newValue) {
      this.team1score = newValue.team1score
      this.team2score = newValue.team2score
    },
    team1score(newValue, oldValue) {
      if (newValue !== oldValue && this.team2score) {
        clearTimeout(this.scoreChangeTimeout)
        this.scoreChangeTimeout = setTimeout(() => {
          this.$emit('onMatchScoreChange', {
            matchId: this.match.id,
            team1score: parseInt(newValue),
            team2score: parseInt(this.team2score),
          })
        }, 500)
      }
    },
    team2score(newValue, oldValue) {
      if (newValue !== oldValue && this.team1score) {
        clearTimeout(this.scoreChangeTimeout)
        this.scoreChangeTimeout = setTimeout(() => {
          this.$emit('onMatchScoreChange', {
            matchId: this.match.id,
            team1score: parseInt(this.team1score),
            team2score: parseInt(newValue),
          })
        }, 500)
      }
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .teamName {
    display: block;
    padding: 1rem 0;
    color: $color-midnight-blue;
    font-size: $font-size-xlarge;
    .fullTeamName {
      display: block;
      font-size: $font-size-small;
    }
  }
  .myPickText {
    font-weight: 600;
    font-size: $font-size-small;
  }
</style>
